<script setup lang="ts">
import type { Organization } from '~~/types/User'

const schoolSelector = useSchoolSelector()

const handleSelect = (selectedJson: string) => {
  const selectedOrganization = JSON.parse(selectedJson) as Organization
  schoolSelector.value.selectedOrganization = selectedOrganization
}
</script>

<template>
  <ModusRadioGroupRoot
    :default-value="JSON.stringify(schoolSelector.currentActiveOrganization)"
    @update:model-value="handleSelect"
  >
    <ModusRadioGroupButton
      v-for="org in schoolSelector.organizations"
      :key="org.number"
      :value="JSON.stringify(org)"
      :label="org.name"
    />
  </ModusRadioGroupRoot>
</template>
